import React, { useEffect } from "react";
import "./Footer.css";
import { Nav, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { appSetup } from "../../features/master/masterSlice";
import { getSocialmedia } from "../../features/socialmedia/Slice";
import { icon } from "@fortawesome/fontawesome-svg-core";
const Footer = () => {
  const location = useLocation();

  const socialIcons = [
    { icon: faLinkedinIn, link: "https://www.linkedin.com" },
    { icon: faFacebookF, link: "https://www.facebook.com" },
    { icon: faXTwitter, link: "https://www.twitter.com" },
    { icon: faInstagram, link: "https://www.instagram.com" },
  ];

  const dispatch = useDispatch();
  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const socialLink = useSelector((state) => state.socialmedia.addSocialmedia);

  useEffect(() => {
    dispatch(getSocialmedia());
  }, [dispatch]);

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="logo_holder">
            <img src="/assets/images/footer/logo.png" className="logo_img" />
          </div>

          <div className="row custom_row">
            <div className="col-xxl-3 col-xl-4 col-lg-4 col-sm-6">
              <div className="col_div">
                <Nav>
                  <div className="first_nav_div">
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/"
                        className={location.pathname === "/" ? "active" : ""}
                      >
                        Home
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/shop"
                        className={
                          location.pathname === "/shop" ? "active" : ""
                        }
                      >
                        Categories
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/about-us"
                        className={
                          location.pathname === "/about-us" ? "active" : ""
                        }
                      >
                        About Us
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/blog"
                        className={
                          location.pathname === "/blog" ? "active" : ""
                        }
                      >
                        Blog
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/contact-us"
                        className={
                          location.pathname === "/contact-us" ? "active" : ""
                        }
                      >
                        Contact Us
                      </NavLink>
                    </Nav.Item>
                  </div>

                  <div className="first_nav_div">
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/terms-conditions"
                        className={
                          location.pathname === "/terms-conditions"
                            ? "active"
                            : ""
                        }
                      >
                        Terms & Conditions
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/privacy-policy"
                        className={
                          location.pathname === "/privacy-policy"
                            ? "active"
                            : ""
                        }
                      >
                        Privacy Policy
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/my-profile"
                        className={
                          location.pathname === "/my-profile" ? "active" : ""
                        }
                      >
                        Your Account
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/wishlist"
                        className={
                          location.pathname === "/wishlist" ? "active" : ""
                        }
                      >
                        Your Wishlist
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink as={Link} to="/faq">
                        FAQs
                      </NavLink>
                    </Nav.Item>
                  </div>
                </Nav>
              </div>
            </div>

            <div className="col-xxl-4 col-xl-3 col-lg-3 col-sm-6">
              <div className="col_div">
                <div className="footer_info_div">
                  <p className="footer_section_title">Customer Support</p>
                  <p className="info_text">Phone: {app_setup?.contact_no}</p>
                  <p className="info_text">Email: {app_setup?.email}</p>
                </div>

                <div className="footer_info_div">
                  <p className="footer_section_title">
                    Phone for Corporate Queries{" "}
                  </p>
                  <p className="info_text">
                    Phone: {app_setup?.alt_contact_no}
                  </p>
                </div>

                <div className="footer_info_div">
                  <p className="footer_section_title">Address</p>
                  <p className="info_text">{app_setup?.address}</p>
                </div>
              </div>
            </div>

            <div className="col-xxl-2 col-xl-2 col-lg-2 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Social Links</p>

                <div className="icons_holder">
                  {socialLink.map((item, index) => (
                    <div className="icon_div">
                      <a
                        key={index}
                        href={item?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="img_holder"
                      >
                        {/* <FontAwesomeIcon
                          icon={item.icon}
                          className="icon_class"
                        /> */}

                        <img
                          src={process.env.REACT_APP_IMG_URL + item?.image}
                          className="icon_class"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3 col-lg-2 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">App Link</p>

                <div className="app_imgs_holder">
                  {/* <div className="img_holder">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="img_holder"
                    >
                      <img
                        src="/assets/images/footer/app.png"
                        className="app_img"
                      />
                    </a>
                  </div> */}

                  <div className="img_holder">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.profcymasolutions.groscido_mobile_app&pcampaignid=web_share"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="img_holder"
                    >
                      <img
                        src="/assets/images/footer/gp.png"
                        className="app_img"
                        alt="Download on Google Play"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer_text_div">
            <p className="footer_text">
              ©{new Date().getFullYear()}{" "}
              <Link to="https://groscido.com" target="_blank">
                Groscido
              </Link>{" "}
              All Rights Reserved 
              {/* | Developed by{" "}
              <Link to="https://profcymaglobal.com" target="_blank">
                Profcyma Solutions Pvt Ltd
              </Link> */}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
